document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGallery();
  initVariantPicker();
  initTabs();
  initCountUp();
  initStoryVideos();
  initWinformatScrub();
});

function initWinformatScrub() {
  var scrubs = document.querySelectorAll('[data-mt-winformat-scrub]');
  if (!scrubs.length) return;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isDesktop = window.matchMedia && window.matchMedia('(min-width: 990px)').matches;
  if (reduceMotion || !isDesktop || !('IntersectionObserver' in window)) return;

  scrubs.forEach(function (scrub) {
    var scene = scrub.closest('.mt-winformat-scene');
    if (!scene) return;
    var images = Array.from(scene.querySelectorAll('.mt-winformat-img'));
    var dots = Array.from(scene.querySelectorAll('.mt-winformat-dot'));
    var progressFill = scene.querySelector('[data-mt-winformat-progress-fill]');
    var captionText = scene.querySelector('[data-mt-winformat-caption-text]');
    var items = Array.from(scrub.querySelectorAll('.mt-winformat-item'));
    if (!items.length) return;
    var total = items.length;
    var captions = items.map(function (item) {
      return item.getAttribute('data-image-label') || '';
    });
    var currentStage = 0;

    function setStage(stage) {
      if (stage === currentStage) return;
      currentStage = stage;
      var progress = total > 1 ? stage / (total - 1) : 1;

      images.forEach(function (img) {
        var imgStage = parseInt(img.getAttribute('data-stage'), 10) || 0;
        img.classList.toggle('mt-active', imgStage === stage);
      });
      dots.forEach(function (dot) {
        var dotStage = parseInt(dot.getAttribute('data-stage'), 10) || 0;
        dot.classList.toggle('mt-active', dotStage === stage);
      });
      items.forEach(function (el) { el.classList.remove('mt-active'); });
      var activeItem = items[stage];
      if (activeItem) activeItem.classList.add('mt-active');
      if (progressFill) progressFill.style.width = (progress * 100) + '%';
      if (captionText && captions[stage] !== undefined) {
        captionText.classList.add('mt-swap');
        window.setTimeout(function () {
          captionText.textContent = captions[stage];
          captionText.classList.remove('mt-swap');
        }, 180);
      }
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var stage = parseInt(entry.target.getAttribute('data-stage'), 10) || 0;
        setStage(stage);
      });
    }, { threshold: 0, rootMargin: '-45% 0px -45% 0px' });

    items.forEach(function (el) { io.observe(el); });
  });
}

function initStoryVideos() {
  var cards = document.querySelectorAll('[data-mt-video-card]');
  if (!cards.length) return;
  cards.forEach(function (card) {
    var video = card.querySelector('.mt-story-video-el');
    var btn = card.querySelector('.mt-story-play');
    if (!video || !btn) return;
    btn.addEventListener('click', function () {
      if (video.paused) {
        video.play();
        card.setAttribute('data-playing', 'true');
      } else {
        video.pause();
      }
    });
    video.addEventListener('pause', function () { card.removeAttribute('data-playing'); });
    video.addEventListener('ended', function () { card.removeAttribute('data-playing'); });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { io.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('mt-open');
      items.forEach(function (i) { i.classList.remove('mt-open'); });
      if (!wasOpen) item.classList.add('mt-open');
    });
  });
}

function initGallery() {
  document.querySelectorAll('[data-mt-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-mt-gallery-main]');
    var thumbs = gallery.querySelectorAll('[data-mt-gallery-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var url = thumb.getAttribute('data-full');
        if (!url) return;
        main.src = url;
        thumbs.forEach(function (t) { t.classList.remove('mt-active'); });
        thumb.classList.add('mt-active');
      });
    });
  });
}

function initVariantPicker() {
  document.querySelectorAll('[data-mt-product-form]').forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variants-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionButtons = form.querySelectorAll('[data-mt-option-value]');
    var idInput = form.querySelector('[data-mt-variant-id]');
    var priceEl = form.querySelector('[data-mt-price]');
    var compareEl = form.querySelector('[data-mt-compare]');
    var addBtn = form.querySelector('[data-mt-add-btn]');

    function selectedOptions() {
      var groups = {};
      form.querySelectorAll('[data-mt-option-group]').forEach(function (group) {
        var name = group.getAttribute('data-mt-option-group');
        var active = group.querySelector('.mt-selected');
        if (active) groups[name] = active.getAttribute('data-mt-option-value');
      });
      return groups;
    }

    function findVariant() {
      var sel = selectedOptions();
      return variants.find(function (v) {
        return Object.keys(sel).every(function (name) {
          return v.optionsByName && v.optionsByName[name] === sel[name];
        });
      });
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.textContent = money(variant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        var addBtnLabel = addBtn.querySelector('span');
        var labelText = variant.available ? addBtn.getAttribute('data-label-available') : addBtn.getAttribute('data-label-sold-out');
        if (addBtnLabel) {
          addBtnLabel.textContent = labelText;
        } else {
          addBtn.textContent = labelText;
        }
      }
    }

    optionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-mt-option-group]');
        group.querySelectorAll('[data-mt-option-value]').forEach(function (b) { b.classList.remove('mt-selected'); });
        btn.classList.add('mt-selected');
        updateUI();
      });
    });

    updateUI();
  });
}

function initTabs() {
  document.querySelectorAll('[data-mt-tabs]').forEach(function (wrap) {
    var btns = wrap.querySelectorAll('[data-mt-tab-btn]');
    var panels = wrap.querySelectorAll('[data-mt-tab-panel]');
    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-mt-tab-btn');
        btns.forEach(function (b) { b.classList.remove('mt-active'); });
        panels.forEach(function (p) { p.classList.remove('mt-active'); });
        btn.classList.add('mt-active');
        var panel = wrap.querySelector('[data-mt-tab-panel="' + target + '"]');
        if (panel) panel.classList.add('mt-active');
      });
    });
  });
}

function initCountUp() {
  var els = document.querySelectorAll('.mt-countup');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      var target = parseFloat(el.getAttribute('data-target') || el.textContent);
      var suffix = el.getAttribute('data-suffix') || '';
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { io.observe(el); });
}
